window.i18n = window.i18n || {};

i18n._langCache = JSON.parse(localStorage.getItem('com.readyforariival.langCache')) || {}

i18n._availableLangs = [
  'en',
  'ja',
  'zh',
  'zh-cn',
  'zh-sg',
  'zh-hk',
  'zh-tw',
]

i18n._updateElements = function () {
  let elements = document.querySelectorAll('*')
  let langPack = i18n._langCache[i18n._lang]
  elements.forEach(function (element) {
    let langIndex = element.getAttribute('data-lang-content')
    if (langIndex) {
      let langTarget = langPack
      langIndex.split('.').forEach(function (layer) {
        if (langTarget[layer]) {
          langTarget = langTarget[layer]
        }
      })
      if (typeof langTarget === 'string') {
        element.innerHTML = langTarget
      }
    }
  })
}

i18n.changeLanguage = function (lang) {
  this._lang = lang

  if ($.cookie('shopify.custom-lang') != lang) {
    $.removeCookie('shopify.custom-lang')
    $.cookie('shopify.custom-lang', lang, { expires: 365, path: '/' });
  }

  if (lang === 'en') {
    window.location.reload()
    return
  }

  if (!i18n._langCache.hasOwnProperty(lang)) {
    let langPackUrl = '//cdn.shopify.com/s/files/1/2146/7017/t/2/assets/custom-[lang].json?193'.replace('[lang]', lang)

    $.ajax({
      url: langPackUrl,
      type: 'GET',
      dataType: 'json',
      async: false
    }).done(function (langPack) {
      i18n._langCache[lang] = langPack
      i18n._updateElements()
      localStorage.setItem('com.readyforariival.langCache', JSON.stringify(i18n._langCache));
    }).fail(function (error) {
      console.error('[fetch language pack error]:', error)
    })
  } else {
    i18n._updateElements()
  }
}

$("#changeLanguageDropdown a").click(function (event) {
  let lang = event.target.getAttribute('data-lang')
  lang && i18n.changeLanguage(lang)
})

i18n.autoDetectLanguage = function () {
  var lang = 'en'
  if ($.cookie && $.cookie('shopify.custom-lang')) {
    lang = $.cookie('shopify.custom-lang')
  } else {
    lang = navigator.languages && navigator.languages[0] ||
               navigator.language ||
               navigator.userLanguage;
  }
  lang = lang.toLowerCase()
  if (i18n._availableLangs.includes(lang) && lang !== 'en') {
    if (lang === 'zh-sg' || lang === 'zh-cn') {
      lang = 'zh'
    } else if (lang === 'zh-tw') {
      lang = 'zh-hk'
    }
    i18n.changeLanguage(lang)
  }
}

i18n.autoDetectLanguage()
